import { Formula, ReportDataTypes } from '~/custom_reports/types'

const ALL_REPORT_DATA_TYPES = Object.freeze(Object.values(ReportDataTypes))

type FormulaConfigType = Record<
  Formula,
  {
    type?: ReportDataTypes
    allowedTypes?: Array<ReportDataTypes>
    validations?: Array<() => any>
    subtitle?: React.ReactElement<any>
    maxFields: number
    minFields: number
    usageLimitations?: {
      formulaFieldDisallowed?: boolean
      filterFieldDisallowed?: boolean
    }
  }
>

// @ts-ignore TODO: ignore undefined formulas. Not implemented yet
export const FormulaConfig: FormulaConfigType = {
  Add: {
    type: ReportDataTypes.Number,
    allowedTypes: [ReportDataTypes.Integer, ReportDataTypes.Number],
    maxFields: 5,
    minFields: 1
  },
  Age: {
    type: ReportDataTypes.Number,
    allowedTypes: [ReportDataTypes.Date, ReportDataTypes.Datetime],
    maxFields: 1,
    minFields: 1
  },
  ArrayToString: {
    type: ReportDataTypes.String,
    allowedTypes: [ReportDataTypes.Array],
    maxFields: 1,
    minFields: 1
  },
  Avg: {
    type: ReportDataTypes.Number,
    allowedTypes: [ReportDataTypes.Number, ReportDataTypes.Integer],
    maxFields: 1,
    minFields: 1
  },
  Case: {
    type: ReportDataTypes.String,
    allowedTypes: ALL_REPORT_DATA_TYPES as Array<ReportDataTypes>,
    maxFields: 60,
    minFields: 1
  },
  Coalesce: {
    allowedTypes: ALL_REPORT_DATA_TYPES as Array<ReportDataTypes>,
    maxFields: 8,
    minFields: 1
  },
  Concat: {
    type: ReportDataTypes.String,
    allowedTypes: [
      ReportDataTypes.Datetime,
      ReportDataTypes.Date,
      ReportDataTypes.Number,
      ReportDataTypes.Integer,
      ReportDataTypes.String
    ],
    maxFields: 7,
    minFields: 2
  },
  Count: {
    type: ReportDataTypes.Number,
    allowedTypes: [
      ReportDataTypes.Datetime,
      ReportDataTypes.Date,
      ReportDataTypes.Number,
      ReportDataTypes.Integer,
      ReportDataTypes.String
    ],
    maxFields: 1,
    minFields: 1
  },
  DateDiff: {
    type: ReportDataTypes.Number,
    allowedTypes: [ReportDataTypes.Datetime, ReportDataTypes.Date],
    maxFields: 2,
    minFields: 1
  },
  DateTrunc: {
    type: ReportDataTypes.Number,
    allowedTypes: [ReportDataTypes.Datetime, ReportDataTypes.Date],
    maxFields: 1,
    minFields: 1
  },
  Divide: {
    type: ReportDataTypes.Number,
    allowedTypes: [ReportDataTypes.Number, ReportDataTypes.Integer],
    maxFields: 2,
    minFields: 1
  },
  Min: {
    allowedTypes: [ReportDataTypes.Datetime, ReportDataTypes.Date, ReportDataTypes.Integer, ReportDataTypes.Number],
    maxFields: 1,
    minFields: 1
  },
  Max: {
    allowedTypes: [ReportDataTypes.Datetime, ReportDataTypes.Date, ReportDataTypes.Integer, ReportDataTypes.Number],
    maxFields: 1,
    minFields: 1
  },
  Multiply: {
    allowedTypes: [ReportDataTypes.Number, ReportDataTypes.Integer],
    maxFields: 2,
    minFields: 1
  },
  PadText: {
    allowedTypes: [ReportDataTypes.String, ReportDataTypes.Integer, ReportDataTypes.Number],
    maxFields: 1,
    minFields: 1
  },
  Round: {
    allowedTypes: [ReportDataTypes.Integer, ReportDataTypes.Number],
    maxFields: 1,
    minFields: 1
  },
  Subtract: {
    type: ReportDataTypes.Number,
    allowedTypes: [ReportDataTypes.Number, ReportDataTypes.Integer],
    maxFields: 2,
    minFields: 1
  },
  Substring: {
    type: ReportDataTypes.String,
    allowedTypes: [ReportDataTypes.Number, ReportDataTypes.Integer, ReportDataTypes.String],
    maxFields: 1,
    minFields: 1
  },
  Sum: {
    type: ReportDataTypes.Number,
    allowedTypes: [ReportDataTypes.Number, ReportDataTypes.Integer],
    maxFields: 8,
    minFields: 1
  },
  ToString: {
    type: ReportDataTypes.String,
    allowedTypes: [ReportDataTypes.Datetime, ReportDataTypes.Date],
    maxFields: 1,
    minFields: 1
  },
  UnNest: {
    type: ReportDataTypes.Array,
    allowedTypes: [ReportDataTypes.Array],
    maxFields: 1,
    minFields: 1,
    usageLimitations: {
      formulaFieldDisallowed: true,
      filterFieldDisallowed: true
    }
  }
}
